
import {defineComponent, PropType, ref} from "vue";
import MovieRating from "@/components/MovieRating.vue";
import iMovie from "@/interfaces/iMovie";
import {imgUrl} from "@/service/MoviesService";

export default defineComponent({
  name: 'MovieGridItem',
  components: {MovieRating},
  emits: ['onMovieClicked'],
  props: {
    movie: {
      type: Object as PropType<iMovie>,
      required: true
    },
  },
  setup(props, {emit}) {
    const movie = ref(props.movie);

    const movieClicked = (): void => {
      emit('onMovieClicked', movie.value.id)
    }

    return {
      imgUrl,
      movieClicked,
    }
  }
})
